import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Col, message, Popconfirm, Row } from "antd";
import { ColumnsType } from "antd/lib/table";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import cmaApi from "../../../../api/cmaApi";
import CheckboxSlider from "../../../../components/SliderList/CheckboxSlider";
import TableWrap from "../../../../components/Table";
import TopContent from "../../../../components/TopContent";
import PageWrap from "../../../../layout/PageWrap";
import { appRoutes } from "../../../../routes/routes";
import { messages } from "../../../../utils/messages";

const CmaCategoriesList = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { data, isLoading, isFetching }: any = useQuery(
    "cma_article_categories",
    cmaApi.getCategories
  );

  const mutation = useMutation(cmaApi.deleteCategory, {
    onSuccess: (data: any) => {
      if (data.statusCode === 200) {
        message.success(messages.deleteSuccess);
        queryClient.invalidateQueries("cma_article_categories");
      } else {
        message.error(data?.data?.message ?? messages.error);
      }
    },
    onError: (err: any) => {
      message.error(err?.data?.message ?? messages.error);
    },
  });

  const mutationEdit = useMutation(cmaApi.editCategory, {
    onSuccess: (data: any) => {
      if (data.statusCode === 200) {
        message.success(messages.updateSuccess);
        queryClient.invalidateQueries("cma_article_categories");
      } else {
        message.error(data?.data?.message ?? messages.error);
      }
    },
    onError: (err: any) => {
      message.error(err?.data?.message ?? messages.error);
    },
  });

  const columns: ColumnsType<any> = [
    {
      title: "STT",
      align: "center",
      width: "5%",
      dataIndex: "stt",
      key: "stt",
    },
    {
      title: "Tên danh mục",
      dataIndex: "ten_vi",
      key: "ten_vi",
    },
    {
      title: "Slug",
      dataIndex: "slug_vi",
      key: "slug_vi",
    },
    {
      title: "Hiển thị",
      dataIndex: "hienthi",
      align: "center",
      width: "8%",
      render: (record: boolean, row: any) => (
        <CheckboxSlider
          _id={row._id}
          check={record}
          dataName="hienthi"
          action={mutationEdit}
        />
      ),
    },
    {
      title: "Sửa",
      align: "center",
      width: "4%",
      render: (_, record: any) => (
        <EditOutlined
          onClick={() =>
            navigate(`${appRoutes.CMA.ARTICLE_CATEGORIES.LIST}/${record?._id}`)
          }
        />
      ),
    },
    {
      title: "Xóa",
      align: "center",
      width: "4%",
      render: (_, record: any) => (
        <Popconfirm
          title="Xác nhận xóa mục này"
          onConfirm={(e: any) => {
            e.preventDefault();
            mutation.mutate(record._id);
          }}
        >
          <DeleteOutlined style={{ color: "red" }} />
        </Popconfirm>
      ),
    },
  ];

  return (
    <PageWrap
      title="CMA · Danh mục bài viết"
      content={
        <div className="slider_list">
          <TopContent
            content={
              <Row>
                <Col>
                  <b>CMA · Danh mục bài viết</b>
                </Col>
                <Col>
                  <Button
                    onClick={() =>
                      navigate(appRoutes.CMA.ARTICLE_CATEGORIES.ADD)
                    }
                  >
                    <PlusOutlined /> Add
                  </Button>
                </Col>
              </Row>
            }
          />
          <div className="content">
            <TableWrap
              loading={isLoading || isFetching}
              columns={columns}
              isShowTotal
              dataSource={data?.data}
              rowKey="_id"
              bordered
              pagination={false}
              className="hover table-slide"
              hasDefaultColumn={false}
            />
          </div>
        </div>
      }
    />
  );
};

export default CmaCategoriesList;
